<div id="divResponseData" class="modal myModalView" style="display:none">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{Response}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hides()">&times;</button>
      </div>
      <div class="modal-body DetailScroll">
        <div class="row">
          <div class="col-sm-4" id="tbldefectmanagement">
            <br />
            <table class="tblBkinfo tblMain table table-bordered" width="100%">
              <tbody>
                <tr>
                  <td class="main"><b>Journal</b></td>
                  <td>{{Acronym}}</td>
                </tr>
                <tr>
                  <td class="main"><b>Issue</b></td>
                  <td>{{VolIssue}}</td>
                </tr>
                <tr>
                  <td class="main"> <b>Article</b></td>
                  <td>{{ArticleNo}}</td>
                </tr>
                <tr>
                  <td class="main"> <b>Defect Area</b></td>
                  <td>{{AreaName}}</td>
                </tr>
                <tr>
                  <td class="main"> <b>Defect Category</b></td>
                  <td>{{Category}}</td>
                </tr>
                <tr>
                  <td class="main"><b>Defect Instruction</b></td>
                  <td>{{Instructions}}</td>
                </tr>
                <tr>
                  <td class="main"><b>Defect Due Date</b></td>
                  <td>{{DefectDueDate}}</td>
                </tr>
                <tr>
                  <td class="main"><b>Defect File</b></td>
                  <td>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="Download" (click)="DefectDataDownloadFiles()"><i class="fa fa-download"></i><b>Support File</b></button>
                  </td>
                </tr>
                <tr>
                  <td class="main"> <b> Description</b> </td>
                  <td>
                    <div class="description">
                      <textarea [(ngModel)]="Description" class="form-control text-ellipsis oblique-text" rows="1" #textArea></textarea>
                      <span class="ellipsis " (click)="openOffCanvasForDescription()" title="View Description"><i class="fa fa-binoculars" aria-hidden="true"></i></span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="main"><b>RootCause User</b></td>
                  <td><input id="Txt_RootCauseuser" type="text" class="form-control" maxlength="40" /></td>
                </tr>
                <tr>
                  <td class="main"><b>Responsible User</b></td>
                  <td><input id="Txt_ResponsibleUser" type="text" class="form-control" maxlength="40" /></td>
                </tr>
                <tr>
                  <td class="main"><b>Complaint Type</b><span class="required" id="spanpreventive">*</span></td>
                  <td>
                    <select id="ddlComplaintType" class="form-control ddlselect">
                      <option value="">Select</option>
                      <option value=1>Internal</option>
                      <option value=2>External</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td class="main"><b>Critical Level</b><span class="required" id="spanpreventive">*</span></td>
                  <td>
                    <select id="ddlCriticalLevel" class="form-control ddlselect">
                      <option value="">Select</option>
                      <option value=1>Low</option>
                      <option value=2>Medium</option>
                      <option value=3>High</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-sm-8" id="">
            <div class="row">
              <div class="col">
                <label>Root Cause</label><span class="required" id="spanroot">*</span>
                <textarea class="form-control rounded-0 oblique-text " id="Txt_rootCause" rows="7" autocomplete="off" style="resize:none"></textarea>
              </div>
            </div>
            <br />
            <div class="row" id="mainRootUpload">
              <div class="col-6 fixed-div" id="defcorrectuploadbtn">
                <span class="required" id="spansizeRoot">[upload size:Max 50MB]</span>
                <input type="file" id="doc_DefectCorrectedFile" class="form-control align-left" (change)="onuploadDataSelected($event,'RootCause')" /><br />
              </div><br />
              <div class="col d-flex justify-content-end" id="divrootDownload">
                <button type="button" class="btn btn-outline-primary waves-effect waves-light btn-sm" id="DownloadCorrectFile" (click)="DefectCorrectedFile('RootCause')"><i class="fa fa-download"></i><b>Correction Defect File</b></button>&nbsp;
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col">
                <label>Corrective Action</label>
                <textarea class="form-control rounded-0 oblique-text " id="Txt_CorrectiveAction" rows="7" autocomplete="off" style="resize:none"></textarea>
              </div>
            </div><br />
            <div class="row" id="mainCorrectiveUpload">
              <div class="col-6 fixed-div" id="defcorrectuploadbtnCorrectiveAct">
                <span class="required" id="spansizeCorrect">[upload size:Max 50MB]</span>
                <input type="file" id="doc_DefectCorrectedFile_crtAct" class="form-control" (change)="onuploadDataSelected($event,'Corrective')" /><br />
              </div>
              <div class="col d-flex justify-content-end" id="divcrtDownload">
                <button type="button" class="btn btn-outline-primary waves-effect waves-light btn-sm" id="DownloadCorrectFileCrtAct" (click)="DefectCorrectedFile('Corrective')"><i class="fa fa-download"></i><b>Correction Defect File</b></button>&nbsp;
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col">
                <label>Preventive Action</label>
                <textarea class="form-control rounded-0 oblique-text " id="Txt_PreventiveAction" rows="6" autocomplete="off" style="resize:none"></textarea>
              </div>
            </div>
            <br />
            <div class="row" id="Status">
              <div class="col-sm-6">
                <label>Defect Status</label>
                <select id="DefectStatus" class="form-control ddlselect">
                  <option value="">Select</option>
                  <option value="Approve">Approve</option>
                  <option value="Reject">Reject</option>
                </select>
              </div>
            </div>
            <div class="row" id="DefectComments">
              <div class="col">
                <label>Comments</label>
                <textarea class="form-control oblique-text" id="txtDefectResponse" style="resize:none" autocomplete="off" rows="6"> </textarea>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" (click)="hides()" id="Close">Cancel</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="OnClick()" id="UpdateIcon">{{popUpButtonText}}</button>
        <button type="button" class="btn btn-outline-info waves-effect waves-light" (click)="ImplementationProcess()" id="Implemented">Implemented</button>
        <button type="button" class="btn btn-outline-warning waves-effect waves-light" (click)="GetClosedDefect()" id="RejectDefect">Reject Defect</button>
        </div>
    </div>
  </div>
</div>
<!-- The Modal -->
<div class="modal" id="myModal" [style.display]="showModalDescription ? 'block' : 'none'">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content" id="divDescription">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title ">Description</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideDescription()">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <p class="oblique-text">{{Description}}</p>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideDescription()">Close</button>
      </div>
    </div>
  </div>
</div>
